import { render, staticRenderFns } from "./mobile-productDescriptionDetail.vue?vue&type=template&id=369fb71f&scoped=true&"
import script from "./mobile-productDescriptionDetail.vue?vue&type=script&lang=js&"
export * from "./mobile-productDescriptionDetail.vue?vue&type=script&lang=js&"
import style0 from "./mobile-productDescriptionDetail.vue?vue&type=style&index=0&id=369fb71f&prod&scoped=true&lang=css&"
import style1 from "./mobile-productDescriptionDetail.vue?vue&type=style&index=1&id=369fb71f&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "369fb71f",
  null
  
)

export default component.exports